import { filter, find, get, size } from 'lodash';

export const getScenarios = (state) => get(state, 'scenarios.allScenarios').slice();
export const getScenarioByUuid = (state, scenarioUuid) =>
  find(get(state, 'scenarios.allScenarios'), { scenarioUuid: scenarioUuid });
export const getActiveScenarioUuid = (state) => get(state, 'scenarios.activeScenarioUuid');
export const getFVSSScenarioUuid = (state) => get(state, 'scenarios.originalScenarioUuid');
export const getFVSSScenario = (state) => getScenarioByUuid(state, getFVSSScenarioUuid(state));
export const getActiveScenario = (state) => getScenarioByUuid(state, getActiveScenarioUuid(state));
export const getNumZonesInActiveScenario = (state) => size(get(getActiveScenario(state), 'zones'));
export const getActiveScenarioPlantingPlanParams = (state) => get(getActiveScenario(state), 'plantingPlanParams');
export const getDiscardedScenarioUuids = (state) => {
  const activeScenarioUuid = getActiveScenarioUuid(state);
  return filter(getScenarios(state), (scenario) =>
  { return scenario.scenarioUuid !== activeScenarioUuid; }).map((scenario) => scenario.scenarioUuid);
};
export const getOriginalScenarioUuid = (state) => get(state, 'scenarios.originalScenarioUuid');
export const showScenariosList = (state) => getScenarios(state).length > 1;
